const carrier = () => ({
    isEdit: false,
    CAR_AUTO_ID:"",
    CAR_NUMBER:"",
    CAR_TYPE:"",
    CAR_BRAND:"",
    CAR_GENERATION:"",
    CAR_CODE:"",
   
})

const state = carrier()

const getters = {
    GET_isEdit: state => state.isEdit,
    GET_CAR_AUTO_ID: state => state.CAR_AUTO_ID,
    GET_CAR_NUMBER: state => state.CAR_NUMBER,
    GET_CAR_TYPE:state => state.CAR_TYPE,
    GET_CAR_BRAND:state => state.CAR_BRAND,
    GET_CAR_GENERATION:state => state.CAR_GENERATION, 
    GET_CAR_CODE:state => state.CAR_CODE,
}
const mutations = {
    SET_isEdit(state, data) {
        state.isEdit = data
    },
    RESET(state) {
        const newState = carrier();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
    SET_CAR_AUTO_ID(state, data) {
        state.CAR_AUTO_ID = data
    },
    SET_CAR_NUMBER(state, data) {
        state.CAR_NUMBER = data
    },
    SET_CAR_TYPE(state, data) {
        state.CAR_TYPE = data
    },
    SET_CAR_BRAND(state, data) {
        state.CAR_BRAND = data
    },
    SET_CAR_GENERATION(state, data) {
        state.CAR_GENERATION = data
    },
    SET_CAR_CODE(state, data) {
        state.CAR_CODE = data
    },
}

const actions = {
    // fetchVariable1({ commit }) {
    //     return new Promise( (resolve, reject) => {
    //            // Make network request and fetch data
    //            // and commit the data
    //            commit('SET_VARIABLE_1', data); 
    //            resolve();
    //     })
    // }
    // remove_weight_contract(context, items){
    //     let data = context.state.WEIGHT_CONTRACT
    //     const index =  data.indexOf(items)
    //     data.splice(index, 1);
    //     context.commit('SET_WEIGHT_CONTRACT',data)
    // },
    car_reset({ commit }) {
        commit('RESET');
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}